import { createContext } from "react";

export const PoliticalPartyDBContext = createContext();